export const isModalOpen = 'isModalOpen';
